export function handleStream(xhr, options) {
    options = Object.assign({}, {
        delimiter: '_STR_DEL_',
        onChunk: () => console.log('On chunk not implemented'),
        onDone: () => console.log('On done not implemented'),
    }, options || {});
    let responseOffset = 0;
    let buffer = '';
    xhr.onreadystatechange = function() {
        if (xhr.readyState === XMLHttpRequest.LOADING ||
            xhr.readyState === XMLHttpRequest.DONE
        ) {
            buffer = buffer + xhr.responseText.substring(responseOffset);
            responseOffset = xhr.responseText.length;
            let end = buffer.indexOf(options.delimiter)
            while (end > 0) {
                options.onChunk(buffer.substring(0, end));
                buffer = buffer.substring(end + options.delimiter.length);
                end = buffer.indexOf(options.delimiter);
            }
            xhr.readyState === XMLHttpRequest.DONE && options.onDone();
        }
    }
}

